import React from 'react'

const Section = ({children}) => {
    return <section>{children}</section>
}

export default Section